function isNumber(x) {
  return x != null && !Number.isNaN(x);
}

function mergeSide(operation, a, b, defaultValue) {
  if (isNumber(a)) {
    return isNumber(b) ? operation(a, b) : a;
  }

  return isNumber(b) ? b : defaultValue;
}

function mergeMarginOrPadding(margin1 = {}, margin2 = {}, mode = 'max', defaultValue = 0) {
  const {
    top,
    left,
    bottom,
    right
  } = margin1;
  const operation = mode === 'max' ? Math.max : Math.min;
  return {
    top: mergeSide(operation, top, margin2.top, defaultValue),
    left: mergeSide(operation, left, margin2.left, defaultValue),
    bottom: mergeSide(operation, bottom, margin2.bottom, defaultValue),
    right: mergeSide(operation, right, margin2.right, defaultValue)
  };
}

export const mergePadding = mergeMarginOrPadding;
export const mergeMargin = mergeMarginOrPadding;